import * as L from 'leaflet';

export class Geocode {
  Latitude: number;
  Longitude: number;

  constructor(latitude: number, longitude: number) {
    this.Latitude = latitude;
    this.Longitude = longitude;
  }

  static convertFromLeafletLatLng(latLng: L.LatLng): Geocode {
    return new Geocode(latLng.lat, latLng.lng);
  }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/pharmacy-locator/models/geocode.ts